import { TranslationKey } from './../../../../../../../../types/translation/TranslationKey';

import React, { useContext } from 'react';
import { translate } from '../../../../../../../../types/translation/Translator';
import { useNavigate } from 'react-router-dom';
import { TaskExportConfigurationContext } from '../../../../../../../../context/TaskExportConfigurationContext';
import DeleteModal from '../../../../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { Routing } from '../../../../../../../../util/routes.util';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import { TaskExportConfigurationRequest } from '../../../../../../../../requests/taskExportConfiguration.request';
import {
  DeleteTaskExportConfigurationInput,
  TaskExportConfigurationInput,
} from '../../../../../../../../types/task_export_configuration';

interface DeleteTaskExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteTaskExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteTaskExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { taskExportConfigurations, setTaskExportConfigurations } = useContext(TaskExportConfigurationContext);

  const [remove, { loading }] = useRequest(TaskExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteTaskExportConfigurationInput[] = [];

    for (const id of ids) {
      const config = taskExportConfigurations.get(id);
      if (config) toDelete.push(new TaskExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      taskExportConfigurations.delete(config.id);
    }

    setTaskExportConfigurations(new Map(taskExportConfigurations));
    handleClose();
    navigate(Routing.tasks.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={translate({ key: TranslationKey.verifyDeleteTaskExportConfiguration })}
      onConfirm={handleDelete}
      loading={loading}
      open={open}
      onClose={handleClose}
    />
  );
}
